import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const JournalEntryInput = () => {
  const { journalEntryId = '' } = useParams();
  const decodedId = journalEntryId ? atob(journalEntryId) : journalEntryId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [periods, setPeriods] = useState([]);
  const [statuses, setStatuses] = useState([
    { value: 'DRAFT', label: 'Draft' },
    { value: 'POSTED', label: 'Posted' },
  ]);
  const route = 'journal_entry';

  useEffect(() => {
    if (journalEntryId) {
      setIsEditing(true);
      fetchJournalEntryDetails();
    }
    fetchPeriods();
  }, [journalEntryId]);

  const fetchJournalEntryDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.journal_entry}${id}/`, { headers });
      const journalEntryDetails = response.data;

      setFormData(journalEntryDetails);
    } catch (error) {
      console.error('Error fetching journal entry details:', error);
    }
  };

  const fetchPeriods = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.financial_period}`, { headers });
      const periods = response.data;

      const periodOptions = periods.map(period => ({
        value: period.id,
        label: `${period.start_date} - ${period.end_date}`,
      }));

      setPeriods(periodOptions);
    } catch (error) {
      console.error('Error fetching periods:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    // Handle form submission success
  };

  const journalEntryFields = [
    {
      name: 'date',
      label: 'Date',
      type: 'date',
    },
    {
      name: 'reference_number',
      label: 'Reference Number',
      type: 'text',
    },
    {
      name: 'description',
      label: 'Description',
      type: 'textarea',
    },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: statuses,
    },
    {
      name: 'period',
      label: 'Period',
      type: 'select',
      options: periods,
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Journal Entry' : 'Create Journal Entry'}</h1>
      <FormComponent
        fields={journalEntryFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default JournalEntryInput;